var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchProfessional(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5886_20970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#323335"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5886_20970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 10C11.55 10 12.0208 9.80417 12.4125 9.4125C12.8042 9.02083 13 8.55 13 8C13 7.45 12.8042 6.97917 12.4125 6.5875C12.0208 6.19583 11.55 6 11 6C10.45 6 9.97917 6.19583 9.5875 6.5875C9.19583 6.97917 9 7.45 9 8C9 8.55 9.19583 9.02083 9.5875 9.4125C9.97917 9.80417 10.45 10 11 10ZM11 14C11.75 14 12.4542 13.8417 13.1125 13.525C13.7708 13.2083 14.3417 12.7583 14.825 12.175C14.2417 11.7917 13.6292 11.5 12.9875 11.3C12.3458 11.1 11.6833 11 11 11C10.3167 11 9.65417 11.1 9.0125 11.3C8.37083 11.5 7.75833 11.7917 7.175 12.175C7.65833 12.7583 8.22917 13.2083 8.8875 13.525C9.54583 13.8417 10.25 14 11 14ZM11 18C8.76667 18 6.875 17.225 5.325 15.675C3.775 14.125 3 12.2333 3 10C3 7.76667 3.775 5.875 5.325 4.325C6.875 2.775 8.76667 2 11 2C13.2333 2 15.125 2.775 16.675 4.325C18.225 5.875 19 7.76667 19 10C19 10.9333 18.85 11.8125 18.55 12.6375C18.25 13.4625 17.8333 14.2167 17.3 14.9L21.3 18.9C21.4833 19.0833 21.575 19.3167 21.575 19.6C21.575 19.8833 21.4833 20.1167 21.3 20.3C21.1167 20.4833 20.8833 20.575 20.6 20.575C20.3167 20.575 20.0833 20.4833 19.9 20.3L15.9 16.3C15.2167 16.8333 14.4625 17.25 13.6375 17.55C12.8125 17.85 11.9333 18 11 18ZM11 16C12.6667 16 14.0833 15.4167 15.25 14.25C16.4167 13.0833 17 11.6667 17 10C17 8.33333 16.4167 6.91667 15.25 5.75C14.0833 4.58333 12.6667 4 11 4C9.33333 4 7.91667 4.58333 6.75 5.75C5.58333 6.91667 5 8.33333 5 10C5 11.6667 5.58333 13.0833 6.75 14.25C7.91667 15.4167 9.33333 16 11 16Z",
    fill: "#323335"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchProfessional);
export default __webpack_public_path__ + "static/media/search-professional.5d0f7a38.svg";
export { ForwardRef as ReactComponent };